export default class PaymentInfoModel {
  constructor() {
    this.debitNote = {
      isDebitNote: false, // 是否為繳款單
      isRegistration: false, // 戶籍地
      isMailingAddress: false, // 通訊地
      isCompanyAddress: false, // 公司地址
      isOtherAddress: false, // 其他地址
      address: '', // 地址
    };
    this.isAutoBillPay = false; // ACH自動扣款
    this.isAutoEDDAPay = false; // eDDA自動扣款
    this.isAPPPay = false; // APP
    this.isLINEPay = false; // LINE
    this.isEmailPay = false; // Email
    this.isSMSPay = false; // SMS
    this.isBankBillPay = false; // 銀行扣款
    this.isPostBillPay = false; // 郵局扣款
    this.isAtmBillPay = false; // ATM扣款
    this.isStoreBillPay = false; // 超商扣款

    this.isBankPay = false; // 支票
    this.bankName = ''; // 銀行
    this.bankSubName = ''; // 分行
    this.accountName = ''; // 戶名
    this.bankAccountNo = ''; // 帳號
  }
}



// WEBPACK FOOTER //
// ./src/models/PaymentInfoModel.js